import type { ReactNode, SVGProps } from "react";

export function LogoutIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="11"
			viewBox="0 0 12 11"
			width="12"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M4.7085 2.95833V1.79167C4.7085 1.48225 4.83141 1.1855 5.05021 0.966709C5.269 0.747916 5.56574 0.625 5.87516 0.625H9.9585C10.2679 0.625 10.5647 0.747916 10.7835 0.966709C11.0022 1.1855 11.1252 1.48225 11.1252 1.79167V8.79167C11.1252 9.10109 11.0022 9.39783 10.7835 9.61662C10.5647 9.83542 10.2679 9.95833 9.9585 9.95833H5.87516C5.56574 9.95833 5.269 9.83542 5.05021 9.61662C4.83141 9.39783 4.7085 9.10109 4.7085 8.79167V7.625"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M7.625 5.29175H0.625L2.375 3.54175"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M2.375 7.04175L0.625 5.29175"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
		</svg>
	);
}
